import { ROUTE_PATH } from 'modules/route/constants'
import getHashStringUtil from 'utils/string/get-hash'
import logUtil from 'utils/log'
import getUrlWithFiltersGiftUtil from 'modules/gift/utils/get-url-with-filters'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'

/**
 *
 * @param props
 * @param props.hasUnlockedSecondTierTracker
 * @param props.hasUnlockedLastTierTracker
 * @param props.isCheckoutMinimumFlow
 * @param props.isNewCustomerSelect
 * @param props.filters
 * @param props.isSelectFreeBonusDeluxeSamplesStep
 * @param props.expressCheckoutPermalink
 */
const getUrlExpressCheckoutSelectUtil = (props) => {
  const {
    hasUnlockedSecondTierTracker,
    hasUnlockedLastTierTracker,
    isCheckoutMinimumFlow,
    isNewCustomerSelect,
    filters,
    isSelectFreeBonusDeluxeSamplesStep,
    expressCheckoutPermalink
  } = props

  logUtil('getUrlExpressCheckoutSelectUtil').debug('props=', props)

  const getUrl = (url) => {
    return getUrlWithFiltersGiftUtil({
      url,
      filters
    })
  }

  if (!isNewCustomerSelect) {
    return expressCheckoutPermalink
  }

  if (isSelectFreeBonusDeluxeSamplesStep) {
    return expressCheckoutPermalink
  }

  if (
    hasUnlockedSecondTierTracker &&
    !hasUnlockedLastTierTracker
  ) {
    const url = isCheckoutMinimumFlow
      ? ROUTE_PATH.SELF_GIFTING_CHECKOUT_MINIMUM
      : ROUTE_PATH.SELF_GIFTING
    return getUrl(
      `${url}${getHashStringUtil(CART_HASH_VALUE_ACTION.SHOW_FREE_BONUS_DELUXE_SAMPLES_MODAL)}`
    )
  }

  if (hasUnlockedLastTierTracker) {
    return getUrl(
      isCheckoutMinimumFlow
        ? ROUTE_PATH.SELF_GIFTING_SELECT_FREE_BONUS_DELUXE_SAMPLES_CHECKOUT_MINIMUM
        : ROUTE_PATH.SELF_GIFTING_SELECT_FREE_BONUS_DELUXE_SAMPLES
    )
  }

  return expressCheckoutPermalink
}

export default getUrlExpressCheckoutSelectUtil
